// Routes Imports
import Pages from './Pages';


// Merge Routes
const routes = [ ...Pages ];

export { routes };
